import React, { useEffect, useState } from 'react';
import {
  Table, Thead, Tbody, Tr, Th, Td, Button,
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter,
  useDisclosure, Flex, IconButton,
  Box
} from '@chakra-ui/react';
import { AddIcon } from '@chakra-ui/icons';
import SolicitudUrbanizacion from '../Ventanas/SolicitudUrbanizacion';

const TablaSolicitudUrbanizacion: React.FC = () => {
  const [data, setData] = useState<any[]>([]);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [modo, setModo] = useState<'view' | 'edit' | 'new'>('view');
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/obras/solicitud-urbanizacion`)
      .then(res => res.json())
      .then(setData)
      .catch(console.error);
  }, []);

  const openModal = (item: any, tipo: 'view' | 'edit') => {
    setSelectedItem(item);
    setModo(tipo);
    onOpen();
  };

  const openNuevo = () => {
    setSelectedItem(null);
    setModo('new');
    onOpen();
  };

  return (
    <Box overflowX="auto" borderRadius="md" boxShadow="md" bg="white" p={4}>
    <Table variant="simple" size="sm">
      <Thead bg="#5b182b">
          <Tr>
            <Th color="white">ID</Th>
            <Th color="white">Tipo Desarrollo</Th>
            <Th color="white">Área (m²)</Th>
            <Th color="white">Costo</Th>
            <Th color="white">Dirección</Th>
            <Th color="white">Acciones</Th>
          </Tr>
        </Thead>
        <Tbody>
          {data.map((item) => (
            <Tr key={item.id}>
              <Td>{item.id}</Td>
              <Td>{item.tipoDesarrollo}</Td>
              <Td>{item.area}</Td>
              <Td>${item.costo}</Td>
              <Td>{item.direccion}</Td>
              <Td>
                <Button size="xs" onClick={() => openModal(item, 'view')}>Ver</Button>{' '}
                <Button size="xs" onClick={() => openModal(item, 'edit')}>Editar</Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>

      <Flex mt={4} justify="center">
        <IconButton
          icon={<AddIcon />}
          aria-label="Agregar nuevo"
          colorScheme="green"
          borderRadius="full"
          size="lg"
          position="fixed"
          bottom="20px"
          right="20px"
           zIndex={10} 

          onClick={openNuevo}
        />
      </Flex>

      <Modal isOpen={isOpen} onClose={onClose} size="6xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {modo === 'view' && 'Ver Solicitud Urbanización'}
            {modo === 'edit' && 'Editar Solicitud Urbanización'}
            {modo === 'new' && 'Nueva Solicitud Urbanización'}
          </ModalHeader>
          <ModalBody>
            <SolicitudUrbanizacion
              modo={modo}
              data={selectedItem}
              onSubmit={() => {
                onClose();
                window.location.reload();
              }}
            />
          </ModalBody>
          <ModalFooter>
            <Button onClick={onClose}>Cerrar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default TablaSolicitudUrbanizacion;